module.exports = __webpack_public_path__ + "img/组 500@2x.a2073f70.png";